import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=753ae168&scoped=true"
import script from "./Referral.vue?vue&type=script&lang=js"
export * from "./Referral.vue?vue&type=script&lang=js"
import style0 from "./Referral.vue?vue&type=style&index=0&id=753ae168&prod&lang=scss&scoped=true"
import style1 from "./Referral.vue?vue&type=style&index=1&id=753ae168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753ae168",
  null
  
)

export default component.exports